module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kg-Lc.65d96b0c.png";